import { ListStateConstant } from './constants/ListStateConstant';

// IMP-307: Admin List 화면 상태(page/검색/정렬/필터) 보존용. checkList(선택)는 보존 대상 아님.
export const ListStateAction = {
    Save:  (stateKey, snapshot) => ({ type: ListStateConstant.SAVE,  stateKey, snapshot }),
    Clear: (stateKey)           => ({ type: ListStateConstant.CLEAR, stateKey }),
};
